import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Route } from 'react-router'
import { Redirect } from 'react-router-dom'
import { AppState } from '../../data/state'
import { getLink } from '../links'
import { Theme } from '../../data/models/funnelOrder/theme';

interface MemberRouteProps extends PropsFromRedux {
  component: React.ComponentClass
  exact: boolean,
  theme?: Theme
}

const MemberRoute: React.FC<MemberRouteProps> = props => {
  const { component: Component, memberToken, country, ...rest } = props

  return (
    <Route
      {...rest}
      render={renderProps =>
        memberToken ? (
          <Component {...renderProps} />
        ) : (
          <Redirect
            to={{
              pathname: getLink(country, 'login'),
              state: { from: renderProps.location },
            }}
          />
        )
      }
    />
  )
}

const mapStateToProps = (state: AppState) => ({
  memberToken: state.member.token,
  country: state.locale.country,
})

const connector = connect(mapStateToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(MemberRoute)
